(function($) {
    'use strict';

    jQuery(document).ready(function($) {
        function tabSwitch(toggle_value) {
            $('[data-tabswitch-toggle]').removeClass('active');
            $('[data-tabswitch-toggle=' + toggle_value + ']').addClass('active');

            $('[data-tabswitch-target]').removeClass('active');
            $('[data-tabswitch-target=' + toggle_value + ']').addClass('active');
        }

        if($('[data-tabswitch-toggle]').length) {
            var hash = $(location).attr('hash').substr(1);
            var busy = false;
            var curr = 0;

            // if there is an anchor in the url that corresponds to a tabswitch target, toggle the tab
            if(hash && $('[data-tabswitch-target=' + hash + ']').length) {
                tabSwitch(hash);
            }

            $(window).on('scroll', function(e) {
                if (busy) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    window.scrollTo(0, curr);
                }
            });

            // toggle the tab
            $(document).on('click', '[data-tabswitch-toggle]', function(e) {
                e.preventDefault();
                busy = true;
                curr = window.scrollY;
                var toggle_value = $(this).data('tabswitch-toggle');

                tabSwitch(toggle_value);
                $(location).attr('hash', toggle_value);
                setTimeout(function() {
                    busy = false;
                }, 200);
            });
        }
    });

})(jQuery);